import Mendel from './Mendel';

export { Mendel };
export { MendelError } from './types/MendelError';
export type { ExperimentData, AssignedVariant } from './types/Experiment';
